import React, { useEffect, useState } from 'react'

import useWidth from 'src/hooks/useWidth'
import { widths as breakpointWidths } from 'src/styles/breakpoints'

type ImageWebpProps = {
  arrayNumbers?: (number | 'auto')[]
  arrayNumbersHeight?: (number | 'auto')[]
  pathSrc: string
  altDescription: string
  className?: string
  title?: string
  style?: React.CSSProperties
  isHero?: boolean
}

const ImageWebp: React.FC<ImageWebpProps> = ({
  arrayNumbers,
  arrayNumbersHeight,
  pathSrc,
  altDescription,
  className,
  style,
  title,
  isHero = false,
}: ImageWebpProps) => {
  const width = useWidth()
  const [isWidth, setIsWidth] = useState<number | 'auto'>(0)
  const [isHeight, setIsHeight] = useState<number | 'auto'>(0)

  useEffect(() => {
    let listPosition = 0
    if (width < breakpointWidths.md) {
      listPosition = 0
    } else if (width >= breakpointWidths.md && width < breakpointWidths.lg) {
      listPosition = 1
    } else if (width >= breakpointWidths.lg && width < breakpointWidths.xl) {
      listPosition = 2
    } else if (width >= breakpointWidths.xl && width < breakpointWidths.xxl) {
      listPosition = 3
    } else if (width >= breakpointWidths.xxl && width < breakpointWidths.xxxl) {
      listPosition = 4
    } else if (width >= breakpointWidths.xxxl) {
      listPosition = 5
    }

    if (arrayNumbers) {
      setIsWidth(arrayNumbers[listPosition] ?? arrayNumbers[arrayNumbers.length - 1] ?? 0)
    }
    if (arrayNumbersHeight) {
      setIsHeight(
        arrayNumbersHeight[listPosition] ?? arrayNumbersHeight[arrayNumbersHeight.length - 1] ?? 0,
      )
    }
  }, [width, arrayNumbers, arrayNumbersHeight])

  return (
    <img
      src={pathSrc}
      alt={altDescription}
      title={title}
      className={className}
      width={isWidth || '100%'}
      height={isHeight || '100%'}
      style={style}
      loading={isHero ? 'eager' : 'lazy'}
      {...({ fetchPriority: isHero ? 'high' : 'low' } as React.ImgHTMLAttributes<HTMLImageElement>)}
    />
  )
}

export default ImageWebp
